import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";

export default function SaveReminderDialog({ open, handleClose }) {
  return (
    <Dialog
      open={open}
      onClose={() => handleClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Do you want to continue without saving?
      </DialogTitle>
      <DialogActions>
        <Button color="success" onClick={() => handleClose(true)}>
          Yes
        </Button>
        <Button color="error" onClick={() => handleClose(false)}>
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
}
